import {
  CsvImportResponse,
  PagedResponse,
  ProductImportResponse,
  ProductListItem,
  ProductsFilterData,
  ProductStates,
  ProductTypes,
} from '../apiTypes';
import { mockGetHoldReasons } from '../hold/holdMock';

export const productListItemTemplate :ProductListItem = {
  brand: 'BOSH',
  category: 'N006',
  currency: 'CZK',
  ean: 'ABC',
  errorMessage: '',
  errorUpdateMessage: '',
  eshopCode: 'ALZA.CZ',
  eshopId: 1,
  eshopName: 'ALZA',
  eshopProductCode: '',
  id: 0,
  inStock: 10,
  deliveryDelay: 10,
  freeDelivery: false,
  parentId: 0,
  partnerCode: '123',
  partnerId: 1,
  partnerName: 'Partner',
  partnerProductCode: '',
  price: 1000,
  forcedPrice: 100,
  useForcedPrice: true,
  status: ProductStates.ACTIVATION_FAILED,
  title: '',
  type: ProductTypes.PRODUCT,
  weightUom: 'GRAM',
  weight: 123,
  asyncOperationId: null,
  minimumPrice: 10,
  temporaryHold: false,
  isInPricing: false,
};

const holdReasons = mockGetHoldReasons.reasons;
const additionalPrices = [
  {
    marketplaceCode: 'ALLEGRO.CZ',
    price: 100,
    minimumPrice: 80,
    forcedPrice: 120,
    vat: 21,
    currency: 'CZK',
    pricingRuleId: 'a7Bk9XmZ2QpL4RtY8WdN',
    base: true,
  },
  {
    marketplaceCode: 'ALLEGRO.SK',
    price: 4,
    minimumPrice: 3,
    forcedPrice: null,
    vat: 10,
    currency: 'EUR',
    pricingRuleId: 'b8Cl0YnA3RqM5SuZ9XeO',
    base: false,
  },
  {
    marketplaceCode: 'ALLEGRO.HU',
    price: 20,
    minimumPrice: null,
    forcedPrice: 30,
    vat: null,
    currency: 'HUF',
    pricingRuleId: null,
    base: false,
  },
];

const productListItems : ProductListItem[] = [];
for (let i = 0; i < 25; i++) {
  productListItems.push({
    ...productListItemTemplate,
    id: i,
    ean: `ABC${i}125${i * 13}`,
    eshopProductCode: `ESHOP_CODE-${i}`,
    deliveryDelay: 1 + (i % 3),
    freeDelivery: ((i % 2) === 0),
    partnerProductCode: `PARTNER_CODE-${i}`,
    title: `Title ${i}`,
    asyncOperationId: ((i % 2) === 0) ? `OPERATION_ID-${i}` : null,
    branchCode: ((i % 4) === 0) ? `CODE ${i}` : undefined,
    shippingGroup: ((i % 3) === 0) ? `GROUP ${i}` : undefined,
    handlingTime: ((i % 3) === 0) ? 3 : undefined,
    temporaryHold: (i % 3) === 0,
    onHoldReason: (i % 3) === 0 ? holdReasons[i % holdReasons.length] : undefined,
    additionalPrices: (i % 3) === 0 ? additionalPrices : undefined,
    automaticPricingRuleId: (i % 3) === 0 ? 'a7Bk9XmZ2QpL4RtY8WdN' : undefined,
    b2bPrice: (i % 3) === 0 ? 100 : undefined,
    b2bPriceCurrency: (i % 3) === 0 ? 'CZK' : undefined,
    supplier: `Supplier-${i}`,
    isInPricing: (i % 2) === 0,
  });
}

export const mockGetProductsList : PagedResponse<ProductListItem> = {
  page: 1,
  total: 1234,
  pageSize: 25,
  data: productListItems,
};

export const mockPartialImport: CsvImportResponse = {
  total: 12,
  failed: 2,
  updated: 9,
  report: '"Product_id (SKU)","Result","Attribute","Value","Message"\n'
    + '"01","ERROR","brand_id","B1","Unknown value B1 for field brand_id."\n'
    + '"02","ERROR","category_id","C2","Unknown value C2 for field category_id."\n',
};

export const mockFullImport: ProductImportResponse = {
  productCount: 200,
  errorCount: 10,
  draftCount: 5,
  skippedCount: 3,
  updatedProducts: 20,
  createdProducts: 100,
  updatedVariants: 30,
  createdVariants: 40,
  errorCsv: '"Product_id (SKU)";"Result";"Attribute";"Value";"Message"\n"01";"ERROR";"longdesc";"01 long xxxx";"Attribute longdesc is too short. Min value defined as long_desc_min_length is 50."\n"01";"ERROR";"label";"SALE";"Product 01 has unknown values for following labels: SALE."\n"01";"ERROR";"label";"SALE,2020-01-01,2020-11-30,";"Product 01 has invalid labels: Label SALE has field label_to in past."\n"01";"ERROR";"brand_id";"B1";"Unknown value B1 for field brand_id."\n"01";"ERROR";"category_id";"C1";"Unknown value C1 for field category_id."\n"02";"ERROR";"longdesc";"02 long xxxx";"Attribute longdesc is too short. Min value defined as long_desc_min_length is 50."\n"02";"ERROR";"brand_id";"B2";"Unknown value B2 for field brand_id."\n"02";"ERROR";"category_id";"C2";"Unknown value C2 for field category_id."\n"V01";"ERROR";"longdesc";"V01 long xxxx";"Attribute longdesc is too short. Min value defined as long_desc_min_length is 50."\n"V01";"ERROR";"label";"LABEL";"Product V01 has unknown values for following labels: LABEL."\n"V01";"ERROR";"label";"LABEL,2020-05-05,2020-07-07,";"Product V01 has invalid labels: Label LABEL has field label_to in past."\n"V01";"ERROR";"brand_id";"B3";"Unknown value B3 for field brand_id."\n"V01";"ERROR";"category_id";"C3";"Unknown value C3 for field category_id."\n"X1";"ERROR";;;"The value [x] is not a valid value for the enumeration type cz.codingbear.mpi.application.resource.entity.csv.Action."\n"X2";"ERROR";"shortdesc";"aa";"Attribute shortdesc is too short. Min value defined as short_desc_min_length is 10."\n"X2";"ERROR";"longdesc";"to short short description";"Attribute longdesc is too short. Min value defined as long_desc_min_length is 50."\n"X2";"ERROR";"brand_id";"B2";"Unknown value B2 for field brand_id."\n"X2";"ERROR";"category_id";"C2";"Unknown value C2 for field category_id."\n"X3";"ERROR";"longdesc";"02 long xxxx";"Attribute longdesc is too short. Min value defined as long_desc_min_length is 50."\n"X3";"ERROR";"brand_id";"B2";"Unknown value B2 for field brand_id."\n"X3";"ERROR";"category_id";"C2";"Unknown value C2 for field category_id."\n"X41";"ERROR";"longdesc";"02 long xxxx";"Attribute longdesc is too short. Min value defined as long_desc_min_length is 50."\n"X41";"ERROR";"brand_id";"B2";"Unknown value B2 for field brand_id."\n"X41";"ERROR";"category_id";"C2";"Unknown value C2 for field category_id."\n"X42";"WARNING";"title";"";"Attribute title is mandatory. Product will be saved as DRAFT."\n"X42";"ERROR";"longdesc";"02 long xxxx";"Attribute longdesc is too short. Min value defined as long_desc_min_length is 50."\n"X42";"ERROR";"brand_id";"B2";"Unknown value B2 for field brand_id."\n"X42";"ERROR";"category_id";"C2";"Unknown value C2 for field category_id."\n"X51";"ERROR";"longdesc";"02 long xxxx";"Attribute longdesc is too short. Min value defined as long_desc_min_length is 50."\n"X51";"ERROR";"brand_id";"B2";"Unknown value B2 for field brand_id."\n"X51";"ERROR";"category_id";"C2";"Unknown value C2 for field category_id."\n"X52";"ERROR";;;"The value [xx] is not a valid value for the enumeration type cz.codingbear.mpi.application.entity.PackageSize."\n',
  returnCsv: '"target_eshop";"action";"variant_group";"variable_parameters";"product_id";"ean";"product_list_title";"title";"shortdesc";"longdesc";"package_size";"brand_id";"in_stock";"delivery_delay";"price";"rrp";"vat";"free_delivery";"weight";"width";"length";"height";"category_id";"media";"parameter_key";"parameter_value";"label";"label_from";"label_to";"promo_price";"promo_from";"promo_to"\n"MALL.CZ";"PUBLISH";"";"";"01";"8324576955727";"";"Update 01";"ok product";"01 long xxxx";"BIGBOX";"B1";"5";"";"2222";"999";"21";"";"100";"10";"20";"30";"C1";"product 01 media 1";"POWER_CLASS";"A";"SALE";"2020-01-01";"2020-11-31";"700";"2020-01-01";"2020-01-11"\n"MALL.CZ";"DRAFT";"";"";"02";"8596457025915";"";"Update 02";"invalid state transition";"02 long xxxx";"BIGBOX";"B2";"10";"2";"2222";"999";"21";"true";"200";"30";"20";"10";"C2";"product 02 media 1";"SIZE_EUR";"32";"";"";"";"";"";""\n"MALL.CZ";"PUBLISH";"jNqaV";"COLOR";"V01";"5993078106741";"Parent product";"Update V01";"ok product";"V01 long xxxx";"";"B3";"20";"";"2222";"999";"21";"";"400";"30";"30";"30";"C3";"variant v01 media 1";"";"";"LABEL";"2020-05-05";"2020-07-07";"";"";""\n"MALL.CZ";"x";"";"";"X1";"8596457025915";"";"Update 02";"invalid action";"02 long xxxx";"BIGBOX";"B2";"10";"2";"2222";"999";"21";"true";"200";"30";"20";"10";"C2";"product 02 media 1";"SIZE_EUR";"32";"";"";"";"";"";""\n"MALL.CZ";"PUBLISH";"";"";"X2";"8596457025915";"";"Update 02";"aa";"to short short description";"BIGBOX";"B2";"10";"2";"2222";"999";"21";"true";"200";"30";"20";"10";"C2";"product 02 media 1";"SIZE_EUR";"32";"";"";"";"";"";""\n"MALL.CZ";"PUBLISH";"";"";"X3";"8596457025915";"";"Update 02";"ok product";"02 long xxxx";"BIGBOX";"B2";"10";"2";"2222";"999";"21";"true";"200";"30";"20";"10";"C2";"product 02 media 1";"SIZE_EUR";"32";"";"";"";"";"";""\n"MALL.CZ";"PUBLISH";"a";"COLOR";"X41";"8596457025915";"";"Update 02";"ok product";"02 long xxxx";"BIGBOX";"B2";"10";"2";"2222";"999";"21";"true";"200";"30";"20";"10";"C2";"product 02 media 1";"COLOR";"red";"";"";"";"";"";""\n"MALL.CZ";"PUBLISH";"a";"COLOR";"X42";"8596457025915";"";"";"no title -> change to draft";"02 long xxxx";"BIGBOX";"B2";"10";"2";"2222";"999";"21";"true";"200";"30";"20";"10";"C2";"product 02 media 1";"COLOR";"green";"";"";"";"";"";""\n"MALL.CZ";"PUBLISH";"b";"COLOR";"X51";"8596457025915";"";"Update 02";"ok product";"02 long xxxx";"BIGBOX";"B2";"10";"2";"2222";"999";"21";"true";"200";"30";"20";"10";"C2";"product 02 media 1";"COLOR";"red";"";"";"";"";"";""\n"MALL.CZ";"PUBLISH";"b";"COLOR";"X52";"8596457025915";"";"Update 02";"invalid package size";"02 long xxxx";"xx";"B2";"10";"2";"2222";"999";"21";"true";"200";"30";"20";"10";"C2";"product 02 media 1";"COLOR";"green";"";"";"";"";"";""\n',
};

export const mockProductExport = `"Marketplace","SKU","EAN","MP ID","Title","Type","Status","Category","Brand","Price","Minimum price","Forced price","Price currency","CZ price","CZ vat","PL price","PL vat","SK price","SK vat","HU price","HU vat","Stock QTY","On hold","Handling time","Delivery delay","Weight [g]","Error message","Branch code","Shipping group"
"MALL.CZ","V01","111","88888888","Variant V01","VARIANT","PUBLISHED_LIVE","C3","B3","600","500",,"CZK",,,,,,,,,"50","false",,,"300",,,"asdfsadfsd-f-va-sdfavsdf"
"MALL.CZ","01","123456789",,"Product 01","PRODUCT","IMPORT_FAILED","C1","B1","1000",,,"CZK","100","21","20","19","4","15","35","10","5","false","2",,"100","test import failed","loc-1","dc2bea6e-a71a-4548-9211-75ec6b528e92"
"MALL.CZ","V02","222","7777777","Variant V02","VARIANT","PUBLISHED_LIVE","C3","B3","800",,"700","CZK",,,,,,,,,"60","false",,,"400",,,"asdfsadfsd-f-va-sdfavsdf"
"MALL.CZ","02","987654321","5497321","Product 02","PRODUCT","PUBLISHED_TEST","C2","B2","1500",,,"CZK",,,,,,,,,"20","false","0","2","200",,"loc-1","asdfsadfsd-f-va-sdfavsdf"
`;

export const mockGetProductsFilterData: ProductsFilterData = {
  brands: ['Brand 1', 'Brand 2', 'Brand 3'],
  categories: ['Category 1', 'Category 2', 'Category 3'],
  statuses: [ProductStates.PUBLISHED_TEST, ProductStates.IMPORT_FAILED, ProductStates.DRAFT],
  suppliers: ['Supplier 1', 'Supplier 2', 'Supplier 3'],
};
